export enum ERROR_CODES {
	MISS_MATCH = 'MISS_MATCH',
	MIN_VALUE = 'MIN_VALUE',
	MAX_VALUE = 'MAX_VALUE',
	INVALID_LENGTH = 'INVALID_LENGTH',
	REQUIRED = 'REQUIRED',
	MAX_SIZE = 'MAX_SIZE',
	INVALID_FORMAT = 'INVALID_FORMAT',
	PAST_DATE = 'PAST_DATE',
}